import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { usePopupActions, usePopupState } from "@store/popupStore";

/**
 * Renders customized snackbars using Material UI's Snackbar and Alert components.
 * It displays popup alerts with specified severity, message, and duration.
 */
export default function CustomizedSnackbars() {
  const popupActions = usePopupActions();
  const AlertState = usePopupState((state) => state.alert);

  return (
    <Snackbar
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      autoHideDuration={AlertState.duration}
      onClose={() => popupActions.closeAlert()}
      open={AlertState.isOpen}
    >
      <Alert
        elevation={6}
        onClose={() => popupActions.closeAlert()}
        severity={AlertState.severity}
        sx={{ borderRadius: "50px", width: "100%" }}
        variant="filled"
      >
        {AlertState.message}
      </Alert>
    </Snackbar>
  );
}
